import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";
import { Router } from "@angular/router";
import { Api, ApiService } from "../../../../../../common/services/api.service";
import { Api3Service } from "../../../../../../common/services/api3.service";
import { Base } from "../../../../../../common/interfaces/base.interfaces";
import { FormControl, FormGroup } from "@angular/forms";
import { takeUntil } from "rxjs/operators";
import { ReplaySubject } from "rxjs";
import * as moment from "moment-timezone";
import { Moment } from "moment-timezone";
import { StorageService } from "../../../../../../common/services/storage.service";
import { SpinnerService } from "../../../../../../common/services/spinner.service";
import { Table } from "../../../../../../common/interfaces/table.interface";
import { Table2Component } from "../../../../../../common/components/table2";
import { UserService } from "../../../../../../common/services/user.service";
import { User } from "../../../../../../common/interfaces/user.interface";
import { Form } from "../../../../../../common/interfaces/form.interface";
import { ToastService } from "../../../../../../common/services/toast.service";
import { AnalyticsService } from "../../../../../../common/services/analytics.service";
import ISelectOption = Form.ISelectOption;
import { TimezonePipe } from "src/modules/common/pipes/timezone.pipe";
import { MatSelect } from "@angular/material/select";


@Component({
    selector: "section-followups-list",
    templateUrl: "list.component.html",
    styleUrls: ["list.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class FollowupsListComponent implements OnInit, OnDestroy {

    private destroy$: EventEmitter<boolean> = new EventEmitter(false);

    @Input()
    public only_my: boolean = false;

    public tiles: boolean = false;

    @Input()
    public favorite: boolean = false;

    @Input()
    public showFilters: boolean = true;

    @Input()
    public state: Base.IState;

    @ViewChild(Table2Component, { static: false })
    public tableRef: Table2Component;

    private warehousesSelectInstance: MatSelect;
    private warehousesSelectListenerAttached: boolean = false;
    private filerConfigTimers: Record<string, any> = {};
    private readonly filerConfigKey: string = "followups_filters";

    @ViewChild("warehousesSelect")
    public set warehousesSelect(select: MatSelect) {
        if (!select || this.warehousesSelectListenerAttached) {
            return;
        }
        this.warehousesSelectInstance = select;
        this.warehousesSelectListenerAttached = true;
        this.warehousesSelectInstance.openedChange
            .pipe(takeUntil(this.destroy$))
            .subscribe((opened: boolean): void => {
                if (opened) {
                    this.setWarehousesOverlayWidth();
                }
            });
    }

    public showStatusSelectAll: boolean = false;
    public showKindSelectAll: boolean = false;
    public showPartnerSelectAll: boolean = false;
    public showWarehouseSelectAll: boolean = false;

    public timezone: string = "";


    /**
     * Table / list options (api url, columns data & title etc)
     * @type {Table.IOptions}
     */
    public listTable: Table.ISettings;

    public showExportButton: boolean = false;

    public filters: FormGroup = new FormGroup({
        status: new FormControl([]),
        kind: new FormControl([]),
        sort_by: new FormControl("timeline_to"),
        only_open: new FormControl(true),
        partner_id: new FormControl([]),
        warehouses: new FormControl([]),
    });

    public kinds: any[] = [];

    public partners: ISelectOption[] = [];
    public warehouses: ISelectOption[] = [];
    public filteredWarehouses: ReplaySubject<ISelectOption[]> = new ReplaySubject(1);
    public warehouseSearch: FormControl = new FormControl(null);

    public constructor(
        private router: Router,
        private apiService: ApiService,
        private api3Service: Api3Service,
        private storageService: StorageService,
        private spinnerService: SpinnerService,
        private userService: UserService,
        private toastService: ToastService,
        private changeDetectorRef: ChangeDetectorRef,
        private timezonePipe: TimezonePipe,
    ) {
    }

    private getUrl(): any {
        return {
            url: ["request"],
            query: {
                type: "followup",
                only_my: this.only_my,
                only_favorite: this.favorite,
                order_id: this.state.params.order || null,
                with_count: [
                    "OrderRemarks"
                ],
                ...this.filters.value
            }
        };
    }

    private getColumns(): Table.ICol[] {
        return [
            {
                data: "order.ref",
                name: "Order.ref",
                title: "Order",
                render: (row: any): string => {
                    if (row.order) {
                        return `<span class="title pointer">
                                ${row.order.ref}
                            </span>`;
                    }
                    return "";
                },
                click: (row: any): void => {
                    if (row.order_id && row.partner) {
                        window.open("/partner/" + row.partner.slug + "/orders/view/id/" + row.order_id, "_blank");
                    }
                },
                sortable: false
            },
            {
                data: "order.status.name",
                name: "Order.Status.name",
                title: "Order status",
                sortable: false
            },
            {
                data: "order.ref",
                title: "",
                render: (row: any): string => {
                    if (row.id) {
                        return `<mat-icon class="mat-icon material-icons pointer" title="Open in new tab">
                            open_in_new
                            </mat-icon>`;
                    }
                    return "";
                },
                click: (row: any): void => {
                    if (row.id) {
                        window.open("/" + this.state.section + "/followups/view/id/" + row.id, "_blank");
                    }
                },
                cssClass: "action",
                sortable: false,
                searchable: false,
                exportable: false
            },
            {
                data: "urgent_request_task.text",
                name: "UrgentRequestTask.text",
                title: "Current task",
                render: (row: any): string => {
                    if (!row.urgent_request_task) {
                        return "";
                    }
                    return `<div class="multicol"><div title="${row.urgent_request_task.text}"
                            class=" title currentTaskColumn">${row.urgent_request_task.text}</div></div>`;
                },
                sortable: false,
            },
            {
                data: "order.order_items.inventory_conversion.warehouse.three_pl.display_name",
                name: "Order.OrderItems.InventoryConversion.Warehouse.ThreePl.display_name",
                title: "ThreePl",
                sortable: false,
                render: (row: any): string => {
                    if (!row.order.order_items || row.order.order_items.length == 0) {
                        return "";
                    }

                    return row.order.order_items.map((item: any) => {
                        return item.inventory_conversion.warehouse.three_pl.display_name;
                    })
                        .filter((value, index, array) => {
                            return array.indexOf(value) === index;
                        })
                        .join(", ");
                },
            },
            {
                data: "title",
                title: "Title",
                render: (row: any): string => {
                    let unreads: string = "";
                    if (Number(row.unread_activities)) {
                        unreads = `
                            <span class="unreads" title="Unread activities">
                                 <mat-icon class="mat-icon material-icons">
                                        notification_important
                                 </mat-icon>
                                 ${row.unread_activitie.length}
                            </span>`;
                    }

                    return `
                        <div class="multicol">
                            <div class="pointer">
                                ${unreads}
                                ${row.title}
                            </div>
                            <small class="text-disabled">
                                ${row.request_latest_message
                            ? row.request_latest_message.message
                                .replace(/<[^>]*>?/gm, " ").trim().substring(0, 90) : ""}
                            </small>
                            <div>
                                <small class="text-disabled">
                                    <mat-icon class="mat-icon material-icons vertical-middle">
                                        low_priority
                                    </mat-icon>
                                   <b class="${["High", "Critical"].indexOf(row.priority) > -1
                            ? "mat-warn" : ""}">
                                    ${row.priority}
                                    </b>
                                   &emsp;
                                    <mat-icon class="mat-icon material-icons vertical-middle">
                                        message
                                    </mat-icon>
                                    ${row.request_messages_count}
                                    &nbsp;
                                    <mat-icon class="mat-icon material-icons vertical-middle">
                                        priority_high
                                    </mat-icon>
                                    ${row.request_tasks_incomplete_count}/${row.request_tasks_count}
                                </small>
                            </div>
                        </div>`;
                },
                click: (row: any): void => {
                    this.router.navigate([
                        this.state.section,
                        "followups",
                        "view",
                        "id",
                        row.id
                    ]);
                }
            },
            {
                data: "timeline_to",
                title: `Due date (${this.timezone})`,
                render: (row: any): string => {
                    return this.buildTimeline(row);
                },
                sortable: false,
                searchable: false
            },
            {
                data: "status",
                title: "Status",
                render: (row: any): string => {
                    return "<div class='status " + row.status + "'>" + row.status + "</div>";
                }
            },
            {
                data: "request_kind.name",
                name: "RequestKind.name",
                title: "Kind",
                sortable: true
            },
            {
                data: "order.main_address.country",
                name: "Order.MainAddress.country",
                title: "Country",
                render: (row: any): string => {
                    if (row.order && row.order.main_address && row.order.main_address.country_iso_2) {
                        return "<img class='flag' src='assets/images/flags/"
                            + row.order.main_address.country_iso_2.toLowerCase().trim() + ".svg' "
                            + "alt='" + row.order.main_address.country + "'>";
                    } else {
                        return "";
                    }
                },
                sortable: false
            },
            {
                data: "order.order_item.inventory_conversion.customers_inventory_name",
                name: "Order.OrderItem.InventoryConversion.customers_inventory_name",
                title: "Warehouse",
                sortable: false,
                render: (row: any): string => {
                    if (!row.order.order_items || row.order.order_items.length == 0) {
                        return "";
                    }

                    return row.order.order_items.map((item: any) => {
                        return item.inventory_conversion.customers_inventory_name;
                    })
                        .filter((value, index, array) => {
                            return array.indexOf(value) === index;
                        })
                        .join(", ");
                },
            },
            {
                data: "order.courier_service.service_name",
                name: "Order.CourierService.service_name",
                title: "Courier service",
                sortable: false
            },
            {
                data: "order.outbound_shipment.estimated_delivery_date",
                name: "Order.OutboundShipment.estimated_delivery_date",
                title: "ETA",
                sortable: false
            },
            {
                data: "request_last_activity.user.name",
                name: "RequestLastActivity.User.name",
                title: "Updated by",
                render: (row: any): string => {
                    if (row.request_last_activity && row.request_last_activity.user) {
                        return `<div class='avatar'
                    style='background-image: url(${row.request_last_activity.user.avatar
                                ? row.request_last_activity.user.avatar
                                : "/assets/images/default-avatar.png"}'></div>
                        ${row.request_last_activity.user.name}`;
                    } else {
                        return "";
                    }
                },
                sortable: false
            },
            {
                data: "request_last_activity.created_at",
                name: "RequestLastActivity.created_at",
                title: "Update date",
                render: (row: any): string => {
                    if (row.request_last_activity && row.request_last_activity.created_at) {
                        return row.request_last_activity.created_at;
                    } else {
                        return "";
                    }
                },
            },
            {
                data: "created_at",
                name: "created_at",
                title: "Creation date",
                render: (row: any): string => {
                    return row.created_at.split(" ")[0];
                },
            },
            {
                data: "creator.name",
                name: "Creator.name",
                title: "Created by",
                render: (row: any): string => {
                    if (row.creator) {
                        return `<div class='avatar' style='background-image: url(${row.creator.avatar
                            ? row.creator.avatar : "/assets/images/default-avatar.png"}'></div> ${row.creator.name}`;
                    } else {
                        return "";
                    }

                },
                sortable: false
            },
        ];
    }

    /**
     * Prepare list/table
     * @returns {void}
     */
    private prepareList(): void {

        const columns: Table.ICol[] = this.getColumns();

        if (this.state.section === "admin") {
            columns.splice(1, 0, {
                data: "partner.icon_path",
                name: "Partner.icon_path",
                title: "Partner",
                render: (row: any): string => {
                    return "<img src='"
                        + row.partner.icon_path
                        + "' alt='"
                        + row.partner.display_name
                        + "' title='"
                        + row.partner.display_name
                        + "'>";
                },
                searchable: false,
                sortable: false
            });
            columns.splice(1, 0, {
                data: "partner.full_name",
                title: "Partner",
                hidden: true
            });
        }

        this.listTable = {
            table_id: "3R5ox9tN",
            api: this.getUrl(),
            actions: [
                {
                    name: "wizard",
                    title: "View",
                    click: (row: any): void => {
                        this.viewFollowup(row);
                    }
                },
                {
                    name: "star",
                    title: "Add to favorites",
                    click: async (row: any): Promise<any> => {
                        this.spinnerService.show();
                        const { message, type }: Api.IResponse = await this.apiService.request(Api.EMethod.Put,
                            ["request", "" + row.id, "favorite"]);
                        this.spinnerService.hide();

                        if (type as string === "success") {
                            this.toastService.show(message, "success");
                            this.tableRef.reload();
                        }
                        AnalyticsService.eventClick("Favorite button");
                    },
                    cssClassFn: (row: any): string => {
                        return row.fav_user ? "mat-accent" : "";
                    }
                },
                {
                    name: "remarks",
                    title: "Remarks",
                    click: async (row: any): Promise<any> => {
                        this.viewFollowup(row);
                    },
                    cssClassFn: (row: any): string => {
                        return row.order_remarks_count ? "mat-accent" : "";
                    },
                    badgeFn: (row: any): string => {
                        return row.order_remarks_count > 0 ? row.order_remarks_count : null;
                    }
                }
            ],
            per_page: 50,
            columns,
            export: {
                file_name: "followups list"
            }

        };
        this.changeDetectorRef.markForCheck();
    }

    private async loadKinds(): Promise<any> {
        const response: any = await this.apiService.request(Api.EMethod.Get,
            this.apiService.getUrl(["request", "kind"]), {}, {
            category: "followup"
        });
        response.data.forEach((value: any): void => {
            this.kinds.push(value.name);
        });
    }

    private async getPartners(): Promise<any> {
        this.partners = this.userService.data.partners.map((partner: User.IPartner): any => {
            return { value: partner.id, name: partner.display_name };
        });
    }

    private async getWarehouses(): Promise<any> {
        const { data }: Api.IResponse = await this.api3Service.request(Api.EMethod.Get, "admin/hubs", {}, {
            relations: ["Warehouse"],
            data_structure: "dataOnly"
        });
        if (data) {
            const hubsMap = new Map<
                string,
                { warehouseName: string; customersName: string; warehouseSlug: string }
            >();

            data.forEach((hub: any) => {
                if (hub.warehouse_slug && hub.customers_inventory_name) {
                    const key = `${hub.warehouse_slug}:${hub.customers_inventory_name}`;
                    const warehouseName = hub.warehouse?.name || hub.warehouse_slug;

                    if (!hubsMap.has(key)) {
                        hubsMap.set(key, {
                            warehouseName,
                            customersName: hub.customers_inventory_name,
                            warehouseSlug: hub.warehouse_slug,
                        });
                    }
                }
            });

            this.warehouses = Array.from(hubsMap.entries())
                .map(([key, hubData]) => ({
                    value: key,
                    name: `${hubData.warehouseName} - ${hubData.customersName}`,
                }))
                .sort((a, b) => a.name.localeCompare(b.name));
            this.filteredWarehouses.next(this.warehouses);
            this.changeDetectorRef.markForCheck();
        }
    }

    private setWarehousesOverlayWidth(): void {
        const panelElement = this.warehousesSelectInstance?.panel?.nativeElement;
        const overlayPane: HTMLElement | null = panelElement?.parentElement || null;
        if (overlayPane && panelElement) {
            const options = panelElement.querySelectorAll("mat-option:not(.select-search-option)");
            let maxWidth = 200;

            options.forEach((option: Element): void => {
                const textElement = option.querySelector(".mdc-list-item__primary-text") as HTMLElement;
                if (textElement) {
                    const textWidth = textElement.scrollWidth;
                    if (textWidth > maxWidth) {
                        maxWidth = textWidth;
                    }
                }
            });

            const finalWidth = Math.min(maxWidth + 80, window.innerWidth * 0.9);
            overlayPane.style.width = `${finalWidth}px`;
            overlayPane.style.minWidth = `${finalWidth}px`;
        }
    }

    private prepareListeners(): void {
        this.filters.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: any): void => {
            if (!this.tiles) {
                this.tableRef.reload(this.getUrl());
            }
            if (this.state.section === "admin") {
                this.persistAdminFilters(value);
            }
        });

        this.warehouseSearch.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: string): void => {
            if (!value) {
                this.filteredWarehouses.next(this.warehouses);
                return;
            }
            const searchValue = value.toLowerCase();
            const filtered = this.warehouses.filter((warehouse: ISelectOption): boolean => {
                return warehouse.name.toLowerCase().includes(searchValue);
            });
            this.filteredWarehouses.next(filtered);
            this.changeDetectorRef.markForCheck();
        });
    }

    public buildTimeline(data: any): string {
        if (data.timeline_to) {
            const from: Moment = moment.tz(data.created_at, "YYYY-MM-DD HH-mm-ss", "Asia/Jerusalem")
                .startOf("day");
            const to: Moment = moment.tz(data.timeline_to, "YYYY-MM-DD HH-mm-ss", "Asia/Jerusalem");
            const now: Moment = moment.tz();
            const timeline_in_tz = this.timezonePipe.transform(
                data.timeline_to,
                "Asia/Jerusalem",
                this.timezone,
                "MMM D HH:mm"
            );
            const diff100: number = to.diff(from, "hours");
            const diffNow: number = now.diff(from, "hours");
            let progress: number = diffNow / (diff100 / 100);
            progress = progress > 0 ? Math.ceil(progress) : 0;
            progress = progress < 100 ? progress : 100;

            const left: number = to.diff(now, "hours");
            const leftMinutes: number = to.diff(now, "minutes");
            let daysLeft: number = 0;
            let hoursLeft: number = 0;
            let minutesLeft: number = 0;
            let cssClass: string = "red";

            if (leftMinutes > 0) {
                daysLeft = Math.floor(left / 24);
                hoursLeft = left - daysLeft * 24;
                minutesLeft = Math.floor(leftMinutes - hoursLeft * 60 - daysLeft * 60 * 24);
                if (leftMinutes > 60) {
                    cssClass = "green";
                } else if (leftMinutes > 30) {
                    cssClass = "yellow";
                }
            }

            return `
                    <div class="timeline ${cssClass}">
                        <div class="progress" style="width:${progress}%"></div>
                        <div class="dates">
                          ${timeline_in_tz}
                        </div>
                        <div class="distance">
                            ${daysLeft}d ${hoursLeft}h ${minutesLeft}m left
                        </div>
                    </div>
                `;
        } else {
            return `
                     <div class="timeline">
                     <div class="dates">
                            -
                        </div>
                        <div class="distance">
                            -
                        </div>
                    </div>
                `;
        }
    }

    public selectAll(form: string): void {
        if (form === "showStatus") {
            if (!this.showStatusSelectAll) {
                this.filters.get("status").setValue(
                    ["New", "Open", "Pending", "On-hold", "Solved", "Closed", "In-progress"]);
            } else {
                this.filters.get("status").setValue([]);
            }
            this.showStatusSelectAll = !this.showStatusSelectAll;
        } else if (form === "showKind") {
            if (!this.showKindSelectAll) {
                this.filters.get("kind").setValue(this.kinds);
            } else {
                this.filters.get("kind").setValue([]);
            }
            this.showKindSelectAll = !this.showKindSelectAll;
        } else if (form === "showPartner") {
            if (!this.showPartnerSelectAll) {
                this.filters.get("partner_id").setValue(this.partners.map(item => item.value));
            } else {
                this.filters.get("partner_id").setValue([]);
            }
            this.showPartnerSelectAll = !this.showPartnerSelectAll;
        } else if (form === "showWarehouse") {
            if (!this.showWarehouseSelectAll) {
                let warehousesToSelect: ISelectOption[] = [];
                if (this.warehouseSearch.value) {
                    const searchValue = this.warehouseSearch.value.toLowerCase();
                    warehousesToSelect = this.warehouses.filter((warehouse: ISelectOption): boolean => {
                        return warehouse.name.toLowerCase().includes(searchValue);
                    });
                } else {
                    warehousesToSelect = this.warehouses;
                }
                const currentValue = this.filters.get("warehouses").value || [];
                const newValue = [...new Set([...currentValue, ...warehousesToSelect.map(item => item.value)])];
                this.filters.get("warehouses").setValue(newValue);
            } else {
                let warehousesToDeselect: ISelectOption[] = [];
                if (this.warehouseSearch.value) {
                    const searchValue = this.warehouseSearch.value.toLowerCase();
                    warehousesToDeselect = this.warehouses.filter((warehouse: ISelectOption): boolean => {
                        return warehouse.name.toLowerCase().includes(searchValue);
                    });
                    const currentValue = this.filters.get("warehouses").value || [];
                    const newValue = currentValue.filter((val: string) => {
                        return !warehousesToDeselect.some(w => w.value === val);
                    });
                    this.filters.get("warehouses").setValue(newValue);
                } else {
                    this.filters.get("warehouses").setValue([]);
                }
            }
            this.showWarehouseSelectAll = !this.showWarehouseSelectAll;
        }
    }

    private getUserScopedKey(base: string): string {
        const userId = this.userService?.data?.id;
        return userId ? `${base}_${userId}` : base;
    }

    private getFilerConfigPath(base: string): string {
        const section = this.state?.section || "admin";
        return `${section}/users/filer-configurations/${this.getUserScopedKey(base)}`;
    }

    private persistAdminFilters(value: any): void {
        this.saveFilerConfiguration(this.filerConfigKey, value);
    }

    private async fetchFilerConfiguration(base: string): Promise<any> {
        const response = await this.api3Service.get(this.getFilerConfigPath(base));
        if (response?.type === Api.EResponseType.error) {
            return null;
        }
        return response?.data ?? null;
    }

    private saveFilerConfiguration(base: string, value: any): void {
        if (this.filerConfigTimers[base]) {
            clearTimeout(this.filerConfigTimers[base]);
        }
        const path = this.getFilerConfigPath(base);
        this.filerConfigTimers[base] = setTimeout((): void => {
            this.api3Service.post(path, { configurations: value })
                .then((): void => {
                    delete this.filerConfigTimers[base];
                })
                .catch((): void => {
                    delete this.filerConfigTimers[base];
                });
        }, 300);
    }

    private async restoreAdminFilters(): Promise<void> {
        const remoteFilters = await this.fetchFilerConfiguration(this.filerConfigKey);
        if (this.isFilterObject(remoteFilters)) {
            this.filters.patchValue(remoteFilters);
        }
    }

    private isFilterObject(filters: any): boolean {
        return filters && typeof filters === "object" && !Array.isArray(filters);
    }

    public viewFollowup(data: any): void {
        this.router.navigate([
            this.state.section,
            "followups",
            "view",
            "id",
            data.id
        ]);
    }

    public switchTemplate(tiles: boolean): void {
        this.tiles = tiles;
        this.storageService.set("followups_template_tiles", tiles);
        this.changeDetectorRef.markForCheck();
        if (!tiles && !this.listTable) {
            this.prepareList();
        }
    }

    public goToActivities(): void {
        this.router.navigate([
            this.state.section,
            "activities"
        ]);
        AnalyticsService.eventClick(this.only_my ?
            "Recent activities (my followups)" :
            "Recent activities (all followups)");
    }

    public resetFilters(): void {
        this.filters.patchValue({
            status: [],
            kind: [],
            sort_by: "timeline_to",
            only_open: true,
            partner_id: [],
            warehouses: []
        });
        this.warehouseSearch.setValue(null);
        this.showStatusSelectAll = false;
        this.showKindSelectAll = false;
        this.showPartnerSelectAll = false;
        this.showWarehouseSelectAll = false;
        if (!this.tiles && this.tableRef) {
            this.tableRef.reload(this.getUrl());
        }
        this.changeDetectorRef.markForCheck();
    }

    public async export(type: string = "csv"): Promise<any> {
        this.spinnerService.show();

        const columns: any = this.getColumns().map((col: Table.ICol): string[] => {
            return [
                col.data,
                col.title
            ];
        });

        const { data, message }: Api.IResponse = await this.apiService.request(Api.EMethod.Get, ["request"],
            {}, {
            export: type,
            columns,
            ...this.filters.value,
            type: "followup",
            only_my: this.only_my,
            only_favorite: this.favorite,
            order_id: this.state.params.order || null,
        });

        this.spinnerService.hide();
        if (data) {
            this.toastService.show(message, "success");
        }
    }

    public async ngOnInit(): Promise<void> {
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.loadKinds();

        this.tiles = this.storageService.get("followups_template_tiles", this.tiles);

        if (this.state.section === "admin") {
            await this.restoreAdminFilters();
        }

        this.changeDetectorRef.markForCheck();
        if (!this.tiles) {
            this.prepareList();
        }

        if (this.state.section === "admin") {
            this.getPartners();
            this.getWarehouses();
        }
        this.prepareListeners();

    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
        Object.keys(this.filerConfigTimers).forEach((key: string): void => {
            clearTimeout(this.filerConfigTimers[key]);
        });
    }
}
